export default "__VITE_ASSET__BCqoUx4$__"